var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useRef, useState, useEffect } from 'react';
function WithDynamicTopMargin(Component) {
    function WihLoadingComponent(_a) {
        var marginBetweenTop = _a.marginBetweenTop, forwardRef = _a.forwardRef, props = __rest(_a, ["marginBetweenTop", "forwardRef"]);
        var boxRef = useRef(forwardRef);
        // const isMounted = useRef(false);
        var _b = __read(useState('0'), 2), mrTop = _b[0], setMrTop = _b[1];
        // useEffect(() => {
        //   // eslint-disable-next-line eqeqeq
        //   if (isMounted.current) {
        //     setMrTop(marginBetweenTop);
        //     updateState();
        //   }
        //   // eslint-disable-next-line react-hooks/exhaustive-deps
        // }, [marginBetweenTop])
        useEffect(function () {
            updateState();
        });
        // useEffect(() => {
        //   isMounted.current = true;
        // }, []);
        function updateState() {
            var elem = boxRef.current;
            if (elem) {
                var offsetTop = elem.offsetTop, offsetHeight = elem.offsetHeight;
                if (offsetTop >= offsetHeight) {
                    // eslint-disable-next-line eqeqeq
                    if (mrTop == '0')
                        setMrTop(marginBetweenTop || '10px');
                }
                else if (mrTop !== '0') {
                    setMrTop('0');
                }
            }
        }
        return React.createElement(Component, __assign({ ref: boxRef }, props, { marginTop: mrTop }));
    }
    ;
    return React.forwardRef(function (props, ref) {
        return React.createElement(WihLoadingComponent, __assign({}, props, { forwardRef: ref }));
    });
}
export default WithDynamicTopMargin;
